import { useEffect } from "react";

const ADS_CONFIG_URL =
  "https://teluguone.com/teluguone-ssr-server/ad.php";

const AdSenseLoader = () => {
  useEffect(() => {

    // Already initialized
    if (window.__TELUGUONE_ADSENSE_PROMISE__) {
      return;
    }

    // Create one shared promise
    window.__TELUGUONE_ADSENSE_PROMISE__ = (async () => {

      try {

        console.log("AdSense: Fetching configuration...");

        const response = await fetch(ADS_CONFIG_URL, {
          cache: "no-cache"
        });

        if (!response.ok) {
          throw new Error(
            `Ad config request failed: ${response.status}`
          );
        }

        const config = await response.json();

        const enabled = config?.googleAds?.enabled;
        const publisherId = config?.googleAds?.publisherId;

        console.log("AdSense config:", config);

        if (!enabled || !publisherId) {
          throw new Error(
            "AdSense disabled or publisher ID missing"
          );
        }

        /*
         * If AdSense script is already present,
         * don't create another one.
         */
        const existingScript = document.querySelector(
          'script[data-teluguone-adsense="true"]'
        );

        if (existingScript) {

          console.log(
            "AdSense: Script already exists"
          );

          // If Google's object is already available
          if (window.adsbygoogle) {
            return true;
          }

          // Wait for existing script
          await new Promise((resolve, reject) => {

            existingScript.addEventListener(
              "load",
              resolve,
              { once: true }
            );

            existingScript.addEventListener(
              "error",
              reject,
              { once: true }
            );

          });

          return true;
        }

        /*
         * Create Google AdSense script
         */
        const script = document.createElement("script");

        script.async = true;

        script.src =
          `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${publisherId}`;

        script.crossOrigin = "anonymous";

        script.setAttribute(
          "data-teluguone-adsense",
          "true"
        );

        console.log(
          "AdSense: Loading Google script..."
        );

        /*
         * IMPORTANT:
         * Wait until Google script has actually loaded.
         */
        await new Promise((resolve, reject) => {

          script.onload = () => {
            console.log(
              "AdSense: Google script loaded successfully"
            );

            resolve();
          };

          script.onerror = () => {
            reject(
              new Error(
                "Failed to load Google AdSense script"
              )
            );
          };

          document.head.appendChild(script);

        });

        /*
         * Make sure adsbygoogle exists
         */
        window.adsbygoogle =
          window.adsbygoogle || [];

        console.log(
          "AdSense: Ready"
        );

        return true;

      } catch (error) {

        console.error(
          "AdSense initialization failed:",
          error
        );

        throw error;
      }

    })();

  }, []);

  return null;
};

export default AdSenseLoader;